const blockingData = {
    "Aturan Anti Cinta": {
      Centers: [
        {
          Center: "Marsha",
          "Blocking 2": "Fiony, Jessi, Lulu, Ella",
          "Blocking 3": "Christy, Muthe, Indah, Greesel, Elin",
          "Blocking 4": "Gracia, Olla, Lia",
          "Blocking 5": "Lulu, Jessi, Lyn",
          "Blocking 6": "Freya, Gracie, Raisha",
          "Blocking 7": "Kathrina, Eli, Danella",
          "Blocking 8": "Freya, Gita, Amanda, Greesel",
          "Blocking 9": "Gita, Kathrina, Lulu, Ella, Daisy",
          "Blocking 10": "Oniel, Indah, Gracie, Michie, Erine, Fritzy",
          "Blocking 11": "Jessi, Lia, Cathy, Lily",
          "Blocking 12": "Cynthia, Alya, Elin, Delynn",
          "Blocking 13": "Indah, Raisha, Danella, Nachia",
          "Blocking 14": "Eli, Oniel, Lulu, Amanda, Gendis, Ribka",
          "Blocking 15": "Chelsea, Levi",
          "Blocking 16": "Olla, Lyn, Anin, Aralie, Lana",
        },
        {
          Center: "Oniel",
          "Blocking 2": "Fiony, Jessi, Lulu, Ella",
          "Blocking 3": "Christy, Muthe, Marsha, Indah, Greesel, Elin",
          "Blocking 4": "Gracia, Olla, Lia",
          "Blocking 5": "Lulu, Jessi, Lyn",
          "Blocking 6": "Freya, Gracie, Raisha",
          "Blocking 7": "Kathrina, Eli, Danella",
          "Blocking 8": "Freya, Gita, Amanda, Greesel",
          "Blocking 9": "Gita, Kathrina, Lulu, Ella, Daisy",
          "Blocking 10": "Oniel, Indah, Gracie, Michie, Erine, Fritzy",
          "Blocking 11": "Jessi, Lia, Cathy, Lily",
          "Blocking 12": "Cynthia, Alya, Elin, Delynn",
          "Blocking 13": "Indah, Raisha, Danella, Nachia",
          "Blocking 14": "Eli, Lulu, Amanda, Gendis, Ribka",
          "Blocking 15": "Marsha, Chelsea, Levi",
          "Blocking 16": "Olla, Lyn, Anin, Aralie, Lana",
        },
        {
          Center: "Muthe",
          "Blocking 2": "Fiony, Jessi, Lulu, Ella",
          "Blocking 3": "Christy, Muthe, Marsha, Indah, Greesel, Elin",
          "Blocking 4": "Gracia, Olla, Lia",
          "Blocking 5": "Lulu, Jessi, Lyn",
          "Blocking 6": "Freya, Gracie, Raisha",
          "Blocking 7": "Kathrina, Eli, Danella",
          "Blocking 8": "Freya, Gita, Amanda, Greesel",
          "Blocking 9": "Gita, Kathrina, Lulu, Ella, Daisy",
          "Blocking 10": "Oniel, Indah, Gracie, Michie, Erine, Fritzy",
          "Blocking 11": "Jessi, Lia, Cathy, Lily",
          "Blocking 12": "Cynthia, Alya, Elin, Delynn",
          "Blocking 13": "Indah, Raisha, Danella, Nachia",
          "Blocking 14": "Eli, Oniel, Lulu, Amanda, Gendis, Ribka",
          "Blocking 15": "Marsha, Chelsea, Levi",
          "Blocking 16": "Olla, Lyn, Anin, Aralie, Lana",
        },
        {
          Center: "Feni",
          "Blocking 2": "Fiony, Jessi, Lulu, Ella",
          "Blocking 3": "Christy, Muthe, Marsha, Indah, Greesel, Elin",
          "Blocking 4": "Gracia, Olla, Lia",
          "Blocking 5": "Lulu, Jessi, Lyn",
          "Blocking 6": "Freya, Gracie, Raisha",
          "Blocking 7": "Kathrina, Eli, Danella",
          "Blocking 8": "Freya, Gita, Amanda, Greesel",
          "Blocking 9": "Gita, Kathrina, Lulu, Ella, Daisy",
          "Blocking 10": "Oniel, Indah, Gracie, Michie, Erine, Fritzy",
          "Blocking 11": "Jessi, Lia, Cathy, Lily",
          "Blocking 12": "Cynthia, Alya, Elin, Delynn",
          "Blocking 13": "Indah, Raisha, Danella, Nachia",
          "Blocking 14": "Eli, Oniel, Lulu, Amanda, Gendis, Ribka",
          "Blocking 15": "Marsha, Chelsea, Levi",
          "Blocking 16": "Olla, Lyn, Anin, Aralie, Lana",
        },
        {
          Center: "Indah",
          "Blocking 2": "Fiony, Jessi, Lulu, Ella",
          "Blocking 3": "Christy, Muthe, Marsha, Greesel, Elin",
          "Blocking 4": "Gracia, Olla, Lia",
          "Blocking 5": "Lulu, Jessi, Lyn",
          "Blocking 6": "Freya, Gracie, Raisha",
          "Blocking 7": "Kathrina, Eli, Danella",
          "Blocking 8": "Freya, Gita, Amanda, Greesel",
          "Blocking 9": "Gita, Kathrina, Lulu, Ella, Daisy",
          "Blocking 10": "Oniel, Gracie, Michie, Erine, Fritzy",
          "Blocking 11": "Jessi, Lia, Cathy, Lily",
          "Blocking 12": "Cynthia, Alya, Elin, Delynn",
          "Blocking 13": "Indah, Raisha, Danella, Nachia",
          "Blocking 14": "Eli, Oniel, Lulu, Amanda, Gendis, Ribka",
          "Blocking 15": "Marsha, Chelsea, Levi",
          "Blocking 16": "Olla, Lyn, Anin, Aralie, Lana",
        },
      ],
    },
    "Cara Meminum Ramune": {
      Centers: [
        {
          Yellow: "Fiony",
          Pink: "Gracia, Jessi",
          Bronze: "Marsha, Oniel",
          Green: "Muthe, Olla",
          Emerald: "Feni, Kathrina, Ella, Michie",
          Azure: "Gita",
          Lilac: "Jessi, Olla, Lia",
          Coral: "Muthe, Greesel, Nala",
          Magenta: "Indah, Amanda, Cathy, Gendis, Nayla",
          "Sky Blue": "Kathrina, Lia, Cynthia, Chelsea",
          Maroon: "Lulu, Raisha, Elin, Fritzy",
          Apricot: "Freya, Ella, Gracie, Alya, Trisha",
          Lime: "Lyn",
          "Baby Blue": "Oniel, Michie, Anin, Lana",
          Navy: "Marsha, Danella, Lyn, Oline",
          Lavender: "Eli, Daisy, Kimmy",
        },
        {
          Yellow: "Christy",
          Pink: "Gracia, Jessi",
          Bronze: "Marsha, Oniel",
          Green: "Muthe, Olla",
          Emerald: "Feni, Kathrina, Ella, Michie",
          Azure: "Gita",
          Lilac: "Jessi, Olla, Lia",
          Coral: "Muthe, Greesel, Nala",
          Magenta: "Indah, Amanda, Cathy, Gendis, Nayla",
          "Sky blue": "Kathrina, Lia, Cynthia, Chelsea",
          Maroon: "Fiony, Lulu, Raisha, Elin, Fritzy",
          Apricot: "Freya, Ella, Gracie, Alya, Trisha",
          Lime: "Lyn",
          "Baby blue": "Oniel, Michie, Anin, Lana",
          Navy: "Marsha, Danella, Lyn, Oline",
          Lavender: "Eli, Daisy, Kimmy",
        },
        {
          Yellow: "Kathrina",
          Pink: "Gracia, Jessi",
          Bronze: "Marsha, Oniel",
          Green: "Muthe, Olla",
          Emerald: "Feni, Ella, Michie",
          Azure: "Gita",
          Lilac: "Jessi, Olla, Lia",
          Coral: "Muthe, Greesel, Nala",
          Magenta: "Indah, Amanda, Cathy, Gendis, Nayla",
          "Sky blue": "Lia, Cynthia, Chelsea",
          Maroon: "Fiony, Lulu, Raisha, Elin, Fritzy",
          Apricot: "Freya, Ella, Gracie, Alya, Trisha",
          Lime: "Lyn",
          "Baby blue": "Oniel, Michie, Anin, Lana",
          Navy: "Marsha, Danella, Lyn, Oline",
          Lavender: "Eli, Daisy, Kimmy",
        },
      ],
    },
    "Ingin Bertemu": {
      Centers: [
        {
          Center: "Trisha",
          "Blocking 2": "Nachia, Erine",
          "Blocking 3": "Oline, Delynn",
          "Blocking 4": "Nayla, Nala, Jemima",
          "Blocking 5": "Ribka, Delynn, Intan",
          "Blocking 6": "Kimmy, Ekin",
          "Blocking 7": "Levi, Nala, Maira",
          "Blocking 8": "Erine, Mikaela",
          "Blocking 9": "Delynn, Giaa",
          "Blocking 10": "Aralie, Auwia",
          "Blocking 11": "Lily, Rilly",
          "Blocking 12": "Virgi",
        },
      ],
    },
    "Pajama Drive": {
      Centers: [
        {
          Center: "Trisha",
          "Blocking 2": "Nayla, Erine",
          "Blocking 3": "Levi, Delynn, Jemima",
          "Blocking 4": "Oline, Aralie",
          "Blocking 5": "Auwia",
          "Blocking 6": "Kimmy, Maira",
          "Blocking 7": "Ekin, Lily, Mikaela",
          "Blocking 8": "Intan",
          "Blocking 9": "Lily, Virgi",
          "Blocking 10": "Nala, Giaa",
          "Blocking 11": "Aralie, Erine, Mikaela",
          "Blocking 12": "Nachia, Ribka, Rilly",
        },
        {
          Center: "Kimmy",
          "Blocking 2": "Nayla, Erine",
          "Blocking 3": "Levi, Delynn, Jemima",
          "Blocking 4": "Oline, Aralie",
          "Blocking 5": "Auwia",
          "Blocking 6": "Maira",
          "Blocking 7": "Trisha, Ekin, Lily, Mikaela",
          "Blocking 8": "Intan",
          "Blocking 9": "Lily, Virgi",
          "Blocking 10": "Nala, Giaa",
          "Blocking 11": "Aralie, Erine, Mikaela",
          "Blocking 12": "Nachia, Ribka, Rilly",
        },
      ],
    },
    "Sambil Menggandeng Erat Tanganku": {
      Centers: [
        {
          Center: "Freya",
          "Blocking 2": "Christy, Marsha, Muthe",
          "Blocking 3": "Fiony, Gita, Feni",
          "Blocking 4": "Gracia, Jessi, Kathrina",
          "Blocking 5": "Olla, Gracie, Danella, Fritzy",
          "Blocking 6": "Greesel, Eli, Oniel, Erine",
          "Blocking 7": "Lulu, Lia, Cathy",
          "Blocking 8": "Lyn, Raisha, Indah",
          "Blocking 9": "Amanda, Danella",
          "Blocking 10": "Cynthia, Gendis, Nala, Lana",
          "Blocking 11": "Elin, Chelsea, Daisy, Kimmy",
          "Blocking 12": "Alya, Anin, Ribka",
        },
        {
          Center: "Ella",
          "Blocking 2": "Christy, Marsha, Muthe",
          "Blocking 3": "Fiony, Gita, Feni",
          "Blocking 4": "Gracia, Jessi, Kathrina",
          "Blocking 5": "Olla, Gracie, Danella, Fritzy",
          "Blocking 6": "Greesel, Eli, Oniel, Erine",
          "Blocking 7": "Lulu, Lia, Cathy",
          "Blocking 8": "Lyn, Raisha, Indah",
          "Blocking 9": "Amanda, Danella",
          "Blocking 10": "Cynthia, Gendis, Nala, Lana",
          "Blocking 11": "Elin, Chelsea, Daisy, Kimmy",
          "Blocking 12": "Alya, Anin, Ribka",
        },
        {
          Center: "Michie",
          "Blocking 2": "Christy, Marsha, Muthe",
          "Blocking 3": "Fiony, Gita, Feni",
          "Blocking 4": "Gracia, Jessi, Kathrina",
          "Blocking 5": "Olla, Gracie, Danella, Fritzy",
          "Blocking 6": "Greesel, Eli, Oniel, Erine",
          "Blocking 7": "Lulu, Lia, Cathy",
          "Blocking 8": "Lyn, Raisha, Indah",
          "Blocking 9": "Amanda, Danella",
          "Blocking 10": "Cynthia, Gendis, Nala, Lana",
          "Blocking 11": "Elin, Chelsea, Daisy, Kimmy",
          "Blocking 12": "Alya, Anin, Ribka",
        },
      ],
    },
     "Pertaruhan Cinta" : {
      Centers: [
        {
          Center: "Christy",
          "Blocking 2": "Freya, Oniel",
          "Blocking 3": "Fiony, Lulu",
          "Blocking 4": "Gracia, Indah, Olla",
          "Blocking 5": "Marsha, Eli, Lyn",
          "Blocking 6": "Jessi, Raisha, Danella",
          "Blocking 7": "Muthe, Amanda, Daisy",
          "Blocking 8": "Gita, Cynthia",
          "Blocking 9": "Michie, Fritzy",
          "Blocking 10": "Lia",
          "Blocking 11": "Greesel, Cathy",
          "Blocking 12": "Gracie, Alya",
        },
        {
          Center: "Kathrina",
          "Blocking 2": "Freya, Oniel",
          "Blocking 3": "Fiony, Lulu",
          "Blocking 4": "Gracia, Indah, Olla",
          "Blocking 5": "Marsha, Eli, Lyn",
          "Blocking 6": "Jessi, Raisha, Danella",
          "Blocking 7": "Muthe, Amanda, Daisy",
          "Blocking 8": "Gita, Cynthia",
          "Blocking 9": "Michie, Fritzy",
          "Blocking 10": "Lia",
          "Blocking 11": "Greesel, Cathy",
          "Blocking 12": "Gracie, Alya",
        },
      ],
    },
    "Kira-Kira Girls": {
      Centers: [
        {
          Center: "Delynn",
          "Blocking 2": "Trisha, Nayla",
          "Blocking 3": "Jemima, Kimmy",
          "Blocking 4": "Intan, Aralie",
          "Blocking 5": "Erine, Levi",
          "Blocking 6": "Kimmy, Nala",
          "Blocking 7": "Lily, Ribka",
          "Blocking 8": "Oline, Mikaela",
          "Blocking 9": "Nachia",
          "Blocking 10": "Auwia, Rilly",
          "Blocking 11": "Giaa, Maira",
          "Blocking 12": "Ekin, Virgi",
        },
        {
          Center: "Erine",
          "Blocking 2": "Trisha, Nayla",
          "Blocking 3": "Jemima, Kimmy",
          "Blocking 4": "Intan, Aralie",
          "Blocking 5": "Levi",
          "Blocking 6": "Kimmy, Nala",
          "Blocking 7": "Lily, Ribka",
          "Blocking 8": "Oline, Mikaela",
          "Blocking 9": "Nachia",
          "Blocking 10": "Auwia, Rilly",
          "Blocking 11": "Giaa, Maira",
          "Blocking 12": "Ekin, Virgi",
        },
      ],
    }
  }

export default blockingData